import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Component } from '@angular/core'
import { Subject, Subscription } from 'rxjs'
import { Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-update-compound',
  templateUrl: './update-compound.component.html',
  styleUrls: ['./update-compound.component.css'],
})
export class UpdateCompoundComponent {
  public compoundId: number
  public isLoading: boolean
  public state: Map<string, any>
  private state$: Subscription
  public isOpen = false
  public propertiesOptions = []
  public propertyAutocomplete$: Subscription
  public onPropertyAutocomplete$ = new Subject<string>()
  public properties$: Subscription
  public properties = []
  public selectedProperties = []

  public tab: string
  public routerEvents$: Subscription

  constructor(
    public store: Store<any>,
    private route: ActivatedRoute,
    public router: Router,
  ) {}

  ngOnInit() {
    this.compoundId = parseInt(this.route.snapshot.paramMap.get('id'))
    this.tab = this.route.snapshot.paramMap.get('tab')

    this.routerEvents$ = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        const urlSegments = e.url.split('/')
        this.tab = urlSegments[urlSegments.length - 1]
      }
    })
  }

  ngOnDestroy() {
    this.routerEvents$.unsubscribe()
  }

  onTabChange(key: string) {
    this.router.navigate([`/compounds`, this.compoundId, key])
  }
}
